import { render, staticRenderFns } from "./productClass.vue?vue&type=template&id=4031280a&scoped=true&"
import script from "./productClass.vue?vue&type=script&lang=js&"
export * from "./productClass.vue?vue&type=script&lang=js&"
import style0 from "./productClass.vue?vue&type=style&index=0&id=4031280a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031280a",
  null
  
)

/* custom blocks */
import block0 from "./productClass.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports